import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Router, Params } from '@angular/router';

import { Observable } from 'rxjs/Observable';

/**
 * This AuthenticationInterceptor will work seamless together with Carefirst WebSeal Implementation.
 * When Webseal detects user lost session, it will block the sercured service call by below steps
 * 1) Forwarding the request to /WSLredirect/redirection.jsp
 * 2) Then redirection.jsp redirect the call to https://member.carefirst.com/mas/pub/handleEAIResponse.json?status=UNAUTHORIZED with a status code
 * 3) Then handleEAIResponse.json will return a json structure that has loginStatus as 'S999'
 * Thus, in our interceptor, when we detect loginStatus as S999, we should force user back to login page.
 */

@Injectable()
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(public router: Router) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).do(
      (res: HttpEvent<any>) => {
        if (res instanceof HttpResponse) {
          if (this.isBlockedByWebSeal(res)) {
            this.router.navigate(['/login']);
            return false;
          } else if (this.hasAlreadyAnotherActiveSession(res)) {
            const error = res.body.error;
            this.router.navigate(['/error'], { skipLocationChange: true, queryParams: error });
            return false;
          } 
          // else if(this.hasGeneralError(res)) {
          //   let generalLoginError: { 
          //     code : 'LOGIN_ERROR_GENERAL',
          //     msg : 'My Account is having issues gathering your member information'
          //   }; 
          //   this.router.navigate(['/error'], { skipLocationChange: true, queryParams: generalLoginError });
          //   return false;        
          // }
        }
      },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          //console.log(err);
        }
      }
    );
  }

  /**
   * We can update this logic based on actual webseal design
   */
  isBlockedByWebSeal(res: HttpResponse<any>) {
    return res.body.loginStatus === 'S999';
  }

  hasAlreadyAnotherActiveSession(res: HttpResponse<any>) {
    return res.body.error && res.body.error.code === '500.001';
  }

  // hasGeneralError(res: HttpResponse<any>) {
  //   return res.body.error; 
  // }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth-interceptor.ts